module.exports = __webpack_public_path__ + "img/tada.ac4453e1.png";